import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Bar, ResponsiveContainer, ComposedChart, ReferenceLine  } from "recharts";
import NoData from "../../NoData/NoData";
import { CustomTooltip, CustomizedTick, generateSymmetricTicksAndDomain, generatePositiveIntegerTicksAndDomain } from "../ChartUtils";

const sampleData = [
  { month: 'Jan 2024', newSKUs: 120, remodeledSKUs: 100, opportunities: -30.2 },
  { month: 'Feb 2024', newSKUs: 150, remodeledSKUs: 130, opportunities: -50.8 },
  { month: 'Mar 2024', newSKUs: 180, remodeledSKUs: 160, opportunities: 45.9 },
  { month: 'Apr 2024', newSKUs: 140, remodeledSKUs: 120, opportunities: 35 },
  { month: 'May 2024', newSKUs: 170, remodeledSKUs: 140, opportunities: 55 }
];

const SCMLineBarChart = ({ linebarchartData }) => {

  const sortedData = linebarchartData;

  // const maxPrimaryValue = Math.max(
  //   ...linebarchartData?.flatMap(item => [parseFloat(item.newSKUs), parseFloat(item.remodeledSKUs)])
  // );
  // const minPrimaryValue = Math.min(
  //   ...linebarchartData?.flatMap(item => [parseFloat(item.newSKUs), parseFloat(item.remodeledSKUs)])
  // );
  // const maxSecondaryValue = Math.max(...linebarchartData?.map(item => parseFloat(item.opportunities)));
  // const minSecondaryValue = Math.min(...linebarchartData?.map(item => parseFloat(item.opportunities)));

  // Helper to determine rounding factor (10s, 100s, 1000s)


  // ===== Helper Functions =====

// ===== Helper Functions =====

// ===== Helper Functions =====

// function getRoundingBase(value) {
//   const absValue = Math.abs(value);
//   if (absValue < 1) return 0.1;
//   if (absValue < 10) return 1;
//   if (absValue < 100) return 5;
//   if (absValue < 1000) return 10;
//   return 100;
// }

// function roundUpToNearest(value, base) {
//   return Math.ceil(value / base) * base;
// }

function roundDownToNearest(value, base) {
  return Math.floor(value / base) * base;
}

// Symmetric ticks and domain (same as before)
// function generateSymmetricTicksAndDomain(maxValue, tickCount = 9) {
//   const intervalCount = tickCount - 1;
//   const step = roundUpToNearest((2 * maxValue) / intervalCount, getRoundingBase(maxValue));
//   const domainMax = step * Math.floor(intervalCount / 2);
//   const domainMin = -domainMax;

//   const ticks = [];
//   for (let i = domainMin; i <= domainMax; i += step) {
//     // ticks.push(i);
//     ticks.push(Number(i.toFixed(2)));
//   }

//   return { ticks, domainMin, domainMax };
// }

// NEW: Positive integer ticks and domain generator
// function generatePositiveIntegerTicksAndDomain(maxValue, tickCount = 5) {
//   const domainMax = Math.ceil(maxValue); // round up to integer
//   const intervalCount = tickCount - 1;
//   const step = Math.ceil(domainMax / intervalCount); // integer step

//   const adjustedDomainMax = step * intervalCount; // ensure max is multiple of step
//   const domainMin = 0;

//   const ticks = [];
//   for (let i = domainMin; i <= adjustedDomainMax; i += step) {
//     // ticks.push(i);
//     ticks.push(Number(i.toFixed(2)));
//   }

//   return { ticks, domainMin, domainMax: adjustedDomainMax };
// }

// ===== Main Tick & Domain Logic =====

// Your data input
const primaryValues = linebarchartData?.flatMap(item => [
  parseFloat(item.newSKUs),
  parseFloat(item.remodeledSKUs)
]);

const secondaryValues = linebarchartData?.map(item => parseFloat(item.opportunities));

// Raw min/max
const minPrimaryValue = Math.min(...primaryValues);
const maxPrimaryValue = Math.max(...primaryValues);
const minSecondaryValue = Math.min(...secondaryValues);
const maxSecondaryValue = Math.max(...secondaryValues);

// Determine if negative domain needed for BOTH based on either minPrimary or minSecondary
const needSymmetricDomain = (minPrimaryValue < 0 || minSecondaryValue < 0);

const absMaxPrimary = Math.max(Math.abs(minPrimaryValue), Math.abs(maxPrimaryValue));
const absMaxSecondary = Math.max(Math.abs(minSecondaryValue), Math.abs(maxSecondaryValue));

const {
  ticks: primaryTicks,
  domainMin: primaryDomainMin,
  domainMax: primaryDomainMax
} = needSymmetricDomain
  ? generateSymmetricTicksAndDomain(absMaxPrimary)
  : generatePositiveIntegerTicksAndDomain(maxPrimaryValue);

const {
  ticks: secondaryTicks,
  domainMin: secondaryDomainMin,
  domainMax: secondaryDomainMax
} = needSymmetricDomain
  ? generateSymmetricTicksAndDomain(absMaxSecondary)
  : generatePositiveIntegerTicksAndDomain(maxSecondaryValue);


// ===== Output =====
// console.log('minPrimaryValue', minPrimaryValue);
// console.log('maxPrimaryValue', maxPrimaryValue);
// console.log('minSecondaryValue', minSecondaryValue);
// console.log('maxSecondaryValue', maxSecondaryValue);

// console.log('Primary Ticks:', primaryTicks);
// console.log('Primary Domain:', [primaryDomainMin, primaryDomainMax]);

// console.log('Secondary Ticks:', secondaryTicks);
// console.log('Secondary Domain:', [secondaryDomainMin, secondaryDomainMax]);


  /* Older Logic For Tick generation
  const generateTicks = (maxValue) => {
    const step = Math.ceil(maxValue / 5); // Step size for 5 intervals
    // console.log([...Array(6)].map((_, i) => i * step));
    return [...Array(6)].map((_, i) => i * step); // Generate ticks at regular intervals
  };
  
  const generateTicksNegative = (maxValue, minValue) => {
    const posStep = Math.ceil(maxValue / 3); // Step size for 5 intervals
    const negStep = Math.ceil(minValue / 3); // Step size for 5 intervals
    // console.log([...Array(6)].map((_, i) => i * step));
    let posArr = [...Array(5)].map((_, i) => i * posStep);
    let negArr = [...Array(5)].map((_, i) => i * negStep);
    return [...posArr, ...negArr] // Generate ticks at regular intervals
  };
  */
  return (
    <>
      {
        sortedData?.length == 0 ? <NoData /> : (
          <>
            <ResponsiveContainer width="100%" height={350}>
      <ComposedChart
        data={sortedData}
        margin={{
          top: 20,
          right: 10,
          left: 10,
          bottom: 50,
        }}
      >
        <CartesianGrid horizontal={true} vertical={false} stroke="#DFDFDF" />
        <YAxis
          label={{
            textAnchor: "middle",
            value: "Opportunity Identified (in $ MN)",
            position: "insideRight",
            angle: -90,
            style: { fontSize: "14px", fontWeight: "700", fill: "#616161"},
            dy: -120,
            dx: 8,
          }}
          orientation="right"
          tickLine={false}
          yAxisId="right"
          allowDecimals={false}
          axisLine={false}
          ticks={secondaryTicks}
          tick={({ x, y, payload }) => (
            <text x={x} y={y + 4} textAnchor="start" fill="#666">
              {payload.value}
            </text>
          )}
          domain={[secondaryDomainMin, secondaryDomainMax]}
          interval={0}
        />

        
        {/* Primary Y Axis */}
        <YAxis
          ticks={primaryTicks}
          axisLine={false}
          tickLine={false}
          allowDecimals={false}
          yAxisId="left"
          domain={[primaryDomainMin, primaryDomainMax]}
          label={{
            angle: -90,
            value: "# SKUs",
            textAnchor: "middle",
            position: "insideLeft",
            style: { fontSize: "14px", fontWeight: "700", fill: "#616161" },
            dy: 50,
          }}
        />

        <XAxis 
          dataKey="month" 
          tickLine={false} 
          tick={<CustomizedTick />} 
          
          interval={0}
        />


        {/* Secondary Y Axis */}
        {/* <YAxis
          yAxisId="right"
          orientation="right"
          axisLine={false}
          tickLine={false}
          allowDecimals={false}
          domain={[0, maxSecondaryValue]}
          // ticks={generateTicks(maxSecondaryValue)}
          label={{
            value: "Opportunity Identified (in $ MN)",
            angle: -90,
            position: "insideRight",
            textAnchor: "middle",
            dy: -120,
            style: { fontSize: "14px", fontWeight: "700", fill: "#616161" },
          }}
        /> */}



  <ReferenceLine y={0} stroke="#888888" yAxisId="right" />

  {/* <ReferenceLine y={0} stroke="#000" strokeDasharray="3 3" yAxisId="right" /> */}

        <Tooltip content={<CustomTooltip />} />

        {/* One Bar */}
        <Bar
          yAxisId="right"
          dataKey="opportunities"
          name="Opportunities Identified"
          barSize={20}
          fill="#0078A7"
        //   radius={[4, 4, 0, 0]}
        />
        {/* Two Lines */}
        <Line
          yAxisId="left"
          type="linear"
          dataKey="newSKUs"
          name="New SKUs"
          stroke="#B05788"
          dot={{ fill: "#B05788", stroke: "#B05788", strokeWidth: 2 }}
          strokeWidth={3}
        />
        {/* <Line
          yAxisId="left"
          type="linear"
          dataKey="remodeledSKUs"
          name="Re-modeled SKUs"
          stroke="#B05788"
          dot={{ fill: "#B05788", stroke: "#B05788", strokeWidth: 2 }}
          strokeWidth={3}
        /> */}

        
      </ComposedChart>
    </ResponsiveContainer>
          </>
        ) 
      }
    </>
    
  );
};

export default SCMLineBarChart;